import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import Home from './components/Home/Home'
import Client from './components/Client/Client'
import Login from './components/FormUser/Login';



function App() {
  return (
    <Router>
      <div className='bloque'>
        <Routes>
          <Route exact path='/' element={<Home/>}/>
          <Route path='/client/:propietarios' element={<Client/>}/>
          <Route path='/login' element={<Login/>}/>

        </Routes>
      </div>
    </Router>
  );
}

export default App;
